import createAction from 'redux-actions/es/createAction';

export const setOptions = createAction('SET_OPTIONS');
